export default async function ResponseDecryption(encryptedResponse, authorizationToken) {
    if (encryptedResponse) {
        const apiUrl = process.env.REACT_APP_UAT_BASE_URL + '/v2/decryptResponse';
        const apiKey = process.env.REACT_APP_UAT_X_API_KEY;
        const decryptionKey = process.env.REACT_APP_ENCRYPTION_KEY;
        
        try {
            const response = await fetch(apiUrl, {
                method: 'POST',
                headers: {
                    'x-api-key': apiKey,
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${authorizationToken}`,
                },
                body: JSON.stringify({
                    encryptedResponse: encryptedResponse,
                    decryptionKey: decryptionKey,
                }),
            });

            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }

            const result = await response.json();
            return result;
        } catch (error) {
            console.error('Decryption failed:', error);
            throw error; // Re-throw the error for the caller to handle
        }
    } else {
        return "Unable to encrypt request";
    }
}